import { type ApiClient, listQueryParams } from "./client";
import type { DealerCredentials, ListQuery, NewDealerUser, Page, UserDetail, UserFilters, UserRow } from "./types";

/** Users: domain operations the UI depends on. Implementations: HTTP (below) and mock (src/api/mock). */
export interface UsersApi {
  list(query: ListQuery<UserFilters>): Promise<Page<UserRow>>;
  get(id: string): Promise<UserDetail>;
  changeRole(input: { userId: string; scope: { type: "organization" | "store"; id: string }; role: string }): Promise<UserDetail>;
  removeMembership(input: { userId: string; storeId: string }): Promise<UserDetail>;
  suspend(id: string, reason: string): Promise<UserDetail>;
  reactivate(id: string): Promise<UserDetail>;
  /** New dealer account in an organization (or adds an existing account to it). */
  create(organizationId: string, input: NewDealerUser): Promise<DealerCredentials>;
  resetPassword(id: string): Promise<DealerCredentials>;
}

/** Dealer accounts. Platform staff are separate accounts and never appear here. */
export function createHttpUsersApi(client: ApiClient): UsersApi {
  return {
    list: (q) => client.call("listUsers", { query: listQueryParams(q) }),
    get: (id) => client.call("getUser", { params: { id } }),
    changeRole: ({ userId, scope, role }) => client.call("changeUserRole", { params: { id: userId }, body: { scope, role } }),
    removeMembership: ({ userId, storeId }) => client.call("removeUserStoreMembership", { params: { id: userId, storeId } }),
    suspend: (id, reason) => client.call("suspendUser", { params: { id }, body: { reason } }),
    reactivate: (id) => client.call("reactivateUser", { params: { id } }),
    create: (organizationId, input) => client.call("createDealerUser", { params: { id: organizationId }, body: input }),
    resetPassword: (id) => client.call("resetUserPassword", { params: { id } }),
  };
}
